import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { ICertificate } from "../types/index";

export const certificateApi = createApi({
  reducerPath: "certificateApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getCertificates: builder.query<{ certificates: ICertificate[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/certificates/dashboard?${queryString}`;
      },
    }),
    getCertificateById: builder.query<ICertificate, string>({
      query: (certificateId) => `/certificates/${certificateId}`,
    }),
    createCertificate: builder.mutation<void, FormData>({
      query: (body) => ({
        url: "/certificates",
        method: "POST",
        body,
      }),
    }),
    updateCertificate: builder.mutation<void, any>({
      query: ({ id, formData }) => ({
        url: `/certificates/${id}`,
        method: "PATCH",
        body: formData,
      }),
    }),
    deleteCertificate: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/certificates/${id}`,
        method: "DELETE",
      }),
    }),
    reorderCertificates: builder.mutation<void, any>({
      query: (body) => ({
        url: `/certificates/reorder`,
        method: "PATCH",
        body: {
          orders: body
        }
      }),
    }),
  }),
});

export const {
  useGetCertificatesQuery,
  useLazyGetCertificatesQuery,
  useDeleteCertificateMutation,
  useCreateCertificateMutation,
  useUpdateCertificateMutation,
  useLazyGetCertificateByIdQuery,
  useReorderCertificatesMutation
} = certificateApi;
